let forms = {
   query_promo_codes: {
      icon: 'fa fa-pound-sign',
      title: 'Query By Date',
      subtitle: 'Query promo codes by Date',
      forms: [
         {
            type: 'datepicker', form_type: 'daterange', format: 'dd-MM-yyyy', placement: 'bottom-end', placeholder: 'Select a date',
            model: 'duration', label: 'Query Date', class: 'col-12 col-md-9', validation: 'required'
         },
      ]
   }
}

let tables = {
   promocodes: {
      icon: 'fa fa-percent',
      title: 'Promo Codes Redemption',
      table_fields: [
         { name: 'ID Number', align: 'l' },
         { name: 'Attendant Name', align: 'l' },
         { name: 'Phone Number', align: 'l' },
         { name: 'Redemption Count', align: 'c' },
         { name: 'Station', align: 'c' },
         // { name: 'Actions', align: 'c' }
      ],
      search_fields: ["code", "csaName","mobileNumber"],
      row_data: [
         { type: 'text', field: 'idNumber', class: 'bold' },
         { type: 'text', field: 'csaName', class: 'bold' },
         { type: 'text', field: 'mobileNumber', class: 'bold' },
         { type: 'text', field: 'cards', class: 'bold bigger center' },
         { type: 'text', field: 'station', class: 'bold center' },
         // {
         //    type: 'action', field: 'name', class: 'center', icon: '', actions: [
         //       // {type: 'title', title: 'Actions'},
         //       { type: 'menu', title: 'View', event: 'product:view' }
         //    ]
         // },
      ]
   },
}

export default {
   forms: utils.generateAllFormData(forms),
   tables
}